import { ReactNode } from "react"

import { faIcon } from "@utils/faIcon"

import { Icon } from "@atoms"

import { ObjectsViewType } from "@organisms/ObjectsView/ObjectsView.types"

export default function getObjectsViewIcon(viewType: ObjectsViewType): ReactNode | null {
    if (viewType === "table") {
        return <Icon icon={faIcon({ name: "table-cells-large", style: "regular" })} size={14} />
    } else if (viewType === "card") {
        return <Icon icon={faIcon({ name: "diagram-cells", style: "regular" })} size={14} />
    } else if (viewType === "timeline") {
        return <Icon icon={faIcon({ name: "regular-timeline-view", style: "kit" })} size={14} />
    } else {
        return null
    }
}
